import {IContact} from '../interfaces/contact.interface';
import {IContactListResponse} from '../interfaces/contact-list-response';
import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {firstValueFrom} from 'rxjs';
import {MyHttpClient} from '../../../shared/services/my-http-client.service';
import {HttpServiceBase} from '../../../core/services/http-service-base';


// used only for contact widget and for some contact widget in projects
@Injectable()
export class ContactService extends HttpServiceBase{

    private contacts: Map<number, IContact[]> = new Map<number, IContact[]>();



    async initContactMap(userId: number): Promise<void> {
        try {
            const response = await firstValueFrom(
                this.httpClient.get<IContactListResponse>(`${this.serverAddress}/v1/users/${userId}/contacts`, {
                    observe: 'body'
                })
            );
            this.contacts[userId] = response.contacts;
        } catch (error) {
            throw error;
        }
    }



    async get(userId: number, email: string): Promise<IContact | null> {
        let userContacts: IContact[];
        try {
            userContacts = this.contacts[userId];
            if (!userContacts) {
                await this.initContactMap(userId);
            }
            userContacts = this.contacts[userId];
            if (!userContacts) {
                return null;
            }
            const result = userContacts.find((contacts: IContact) => {
                return contacts.email.toLowerCase() === email.toLowerCase();
            });
            return result ? result : null;
        } catch (error) {
            throw error;
        }
    }

}
